import { createSlice } from '@reduxjs/toolkit';

type InitialState = {
	isSideBarOpen: boolean;
};

const initialState: InitialState = {
	isSideBarOpen: false,
};

const sideBarReducer = createSlice({
	name: 'sideBar',
	initialState,
	reducers: {
		setSideBarOpen: (state, action) => {
			state.isSideBarOpen = action.payload;
		},
	},
});

export const { setSideBarOpen } = sideBarReducer.actions;
export default sideBarReducer;
